import { useMutation, useQueryClient } from 'react-query';
import apiEndPoints from 'services/apiEndPoints';
import makeApiRequest from 'services/makeApiRequest';
import { SuccessToast, ErrorToast } from 'services/toasterService';

export default function useAddTaskBoardChannel(closeModal, reset) {
  const queryClient = useQueryClient();
  return useMutation(
    async (data) => {
      const response = await makeApiRequest.post(
        apiEndPoints.TASKBOARD_API,
        data
      );
      return response?.data;
    },
    {
      onSuccess: (data) => {
        closeModal();
        reset({});
        SuccessToast({ text: data?.message });
        queryClient.invalidateQueries('get-all-channels');
      },
      onError: (error) => {
        ErrorToast({ text: error.response.data.message });
      },
    }
  );
}
